/* eslint-disable react/jsx-no-undef */
import * as React from 'react'
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { AboutUsContent, BaseDiv, DoubleInput, TextBody, TextContent } from './styles';
import Input from '../../../../Input';
import Button from '../../../../Button';
import Services from '../../../../../services/service';
import { useToast } from '../../../../../hooks/toast';
import Select from '../../../../Select';

interface INavBar {
    
}

const Formulario: React.FC<INavBar> = () => {

    const formRef = React.useRef<FormHandles>(null);
    const servicesForm = { FormService: new Services() };
    const [selectedOption, setSelectedOption] = React.useState();
    const { addToast } = useToast();

    const Options = [
      { value: "duvida", label: "Dúvida" },
      { value: "critica", label: "Crítica" },
      { value: "sugestao", label: "Sugestão" },
      { value: "elogio", label: "Elogio" },
    ];

    const handleRecargaChange = React.useCallback((option: any) => {
      setSelectedOption(selectedOption);
    }, []);

    const handleSubmit = React.useCallback(
        async (data: any) => {
          try {
            formRef.current?.setErrors({});
      
            console.log(data);
            const newSubject = Options.filter((info) => info.value === data?.subject ? info.label : '' )
            console.log(newSubject);
            const response = await servicesForm.FormService.postContato({
              name: data.name,
              email: data.email,
              phone: data.phone,
              subject: data.subject,
              message: data.message,
            });
            console.log(response.data);
            addToast({
              type: 'success',
              title: 'Sucesso',
              description: response.data.message,
            });
          } catch (err: any) {
            const { ...error } = err;

            console.log(error);
           
            addToast({
                type: 'error',
                title: 'Erro ao enviar o formulario',
                description:'Verifique se todos os campos preenchidos estão preenchidos corretamente.',
            });
            
          }
        },
        [addToast, useToast],
      );

    return (
        <BaseDiv>
            <AboutUsContent>
                <TextContent>
                    <TextBody>
                        <Form ref={formRef} onSubmit={handleSubmit} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <Input name='name' label='Nome'/>
                            <Input name='email' label='E-mail'/>
                            <Input name='phone' label='Telefone' />
                            <Select
                              name="subject"
                              placeholder="Recarga"
                              defaultValue={{
                                value: "duvida",
                                label: "Dúvida",
                              }}
                              label='Qual assunto?'
                              className="select"
                              isSearchable={false}
                              value={selectedOption}
                              onChange={handleRecargaChange}
                              options={Options}
                            />
                            <Input name='message' label='Digite sua mensagem' multiline />
                            <Button color='orange' padding={'10px'}type="submit" style={{ backgroundColor: "#ffc742", color: "var(--setra-blue)", border: "1px solid var(--text)" }}>
                                ENVIAR
                            </Button>
                        </Form>
                    </TextBody>
                </TextContent>
            </AboutUsContent>
        </BaseDiv>
    );
}

export { Formulario }